
import React, { Component } from 'react';
import './Style.css';
import NotFound from '../../../images/empty.svg';
import '../../../custom.css';
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';

export class AdminPlan extends Component {

    constructor(props) {
        super(props);
        this.state = {
            plans: [],
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
            paramFilter: undefined
        }

    }

    componentDidMount() {
        this.GetPlansByFilterForAdmin();
    }

    async GetPlansByFilterForAdmin() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetPlansByFilterForAdmin?paramFilter=${this.state.paramFilter}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ plans: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async removePlan() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` }
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/RemoveFromAdmin?planId=${this.state.removeId}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'Plan elminado con correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
            this.GetPlansByFilterForAdmin();
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'no se pudo eliminar el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async UpdateStatePlan() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` }
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/UpdateStatePlan?state=Publicado&planId=${this.state.planId}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'El plan se ha publicado correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'publicando el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="mt-5">

                <div className="row filter mb-5">
                    <div className="row col-lg-12 form-group">
                        Buscar plan
                        <input type="text" className="form-control" placeholder="Ingresa el titulo, el autor o la descripción que deseas buscar" onChange={(e) => {

                            this.setState({ paramFilter: e.currentTarget.value })

                        }}></input>
                    </div>
                    <div className="row col-lg-12 form-group">
                        <input type="button" className="btn btn-primary" value="Buscar" onClick={() => { this.GetPlansByFilterForAdmin();}}></input>
                    </div>
                    
                </div>

                <div className="row result">
                    <div className="col-lg-2">
                        Titulo
                    </div>
                    <div className="col-lg-2">
                        Descripción
                    </div>
                    <div className="col-lg-1">
                        Autor
                    </div>
                    <div className="col-lg-2">
                        Estado
                    </div>
                    <div className="col-lg-1">
                        Días
                    </div>
                    <div className="col-lg-1">
                        Foto
                    </div>
                    <div className="col-lg-1">
                    </div>
                    <div className="col-lg-1">
                    </div>
                </div>
                {
                    this.state.plans.map(a =>
                    <div className="row">
                    <div className="col-lg-2">
                                {a.title}
                    </div>
                    <div className="col-lg-2">
                                { a.description}
                    </div>
                    <div className="col-lg-1">
                                { a.author}
                    </div>
                    <div className="col-lg-2">
                                {a.status}
                    </div>
                    <div className="col-lg-1">
                                { a.numberOfDays}
                    </div>
                            <div className="col-lg-1">
                                <img src={a.photo} title={a.title} className="w-100"></img>
                    </div>

                        <div className="col-lg-1">
                                <a href={`/comunidad/plan/form/${a.id}`}>Editar</a>
                            </div>
                            <div className="col-lg-1">
                                <a type="button" href="#" data-toggle="modal" data-target="#openModalPublish" onClick={() => { this.setState({ planId: a.id }) }}>
                                    Publicar
                                </a>
                            </div>
                        <div className="col-lg-1">
                                <a type="button" href="#" data-toggle="modal" data-target="#exampleModalCenter" onClick={() => { this.setState({ removeId: a.id }) }}>
                                    Borrar
                                </a>
                        </div>
                    </div>
                    )
                }


                <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Confirmar plan</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                Está seguro que desea borrar este plan, si borras se perderan los datos de las personas que ya están ejecutandolo?
                                    </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                <button type="button" class="btn btn-primary" data-dismiss="modal" onClick={() => { this.removePlan(); }}>Sí, borrar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="openModalPublish" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Confirmar plan</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                Está seguro que desea publicar este plan, no podrás volver a cambiar su estado.
                                    </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                <button type="button" class="btn btn-primary" data-dismiss="modal" onClick={() => { this.UpdateStatePlan(); }}>Sí, publicar</button>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }} /> : null}
                {this.state.loading ? <Loading /> : null}
            </div >
        );
    }
}
